import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import StreamFields from './formGroup24OutputStreamFields';

export default {
  title: 'Cameras',
  attributeName: 'cameras',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      required: true,
      helpText: 'Set the Name.',
      errorText: '',
    },
    {
      attributeName: 'streamSelected',
      label: 'Stream selected',
      helpText: 'Type stream selected.',
      type: FormInputTypes.SELECT,
      hidden:true,
      default:'1',
      options: [
        { name: '1', value: '1' },
      ],
    },
    {
      attributeName: 'streams',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any stream yet.",
      columns:1,
      label: 'Streams',
      itemLabel:'Stream',
      required: true,
      helpText: 'Insert new streams clicking in + button.',
      errorText: '',
      extraValues:['deploymentType','type','source'],
      classCss:"jsonComponent__width100",
      popupFormGroups:[
        StreamFields

      ]
    },
  ]
};
